// removed by extract-text-webpack-plugin
module.exports = {"grid-figure":"_2fvQyVgTsVxL3cvFH3l15k","control-buttons":"_39TyNYQeNr1-OKRsvd9SE8"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/CardEdit.styl
// module id = 181
// module chunks = 0